import type { ColDef } from 'ag-grid-community';

export const creditColumnDefinitions: ColDef[] = [
  {
    field: 'transactionType',
    sort: 'asc',
    type: 'string',
  },
  {
    field: 'name',
    type: 'string',
  },
  {
    field: 'seniorityType',
    type: 'string',
  },
  {
    field: 'currency',
    type: 'currency',
  },
  {
    field: 'isin',
    type: 'string',
  },
  {
    field: 'id',
    type: 'string',
  },
];
